<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10"><span class="th11">Copyright</span></h1>
<p class="p1"><span class="t2"><img alt="img2.jpg" height="97" src="Images/img2.jpg" width="97"/></span></p>
<p class="p0"><span class="t2">Publicado por</span></p>
<p class="p1">D<span class="t3">REAMSPINNER</span> P<span class="t3">RESS</span></p>
<p class="p0"><span class="t2">5032 Capital Circle SW, Suite 2, PMB# 279, Tallahassee, FL 32305-7886  USA</span></p>
<p class="p1"><span class="t2">http://www.dreamspinnerpress.com/</span></p>
<p class="p2"><span class="t2">Esta historia es ficción. Los nombres, personajes, lugares y acontecimientos son producto de la imaginación del autor o se utilizan para la ficción y cualquier semejanza con personas vivas o muertas, negocios, eventos o escenarios, es mera coincidencia.</span></p>
<p class="p3"><span class="t2">De la A a la Z</span></p>
<p class="p3"><span class="t2">Edición de copyright en español © 2015 Dreamspinner Press.</span></p>
<p class="p3"><span class="t2">Título original: A to Z</span></p>
<p class="p3"><span class="t2">© 2010 Marie Sexton.</span></p>
<p class="p2"><span class="t2">Traducido por: Cristina P. Pérez.</span></p>
<p class="p3"><span class="t2">Portada:  </span></p>
<p class="p3"><span class="t2">© 2010 Mara McKennen.</span></p>
<p class="p3"><span class="t2">Diseño de portada:</span></p>
<p class="p3"><span class="t2">© 2010 Anne Cain annecain.art@gmail.com.</span></p>
<p class="p2"><span class="t2">El contenido de la portada ha sido creado exclusivamente con propósito ilustrativo y todas las personas que aparecen en ella son modelos.</span></p>
<p class="p2"><span class="t2">La licencia de este libro pertenece exclusivamente al comprador original. Duplicarlo o reproducirlo por cualquier medio es ilegal y constituye una violación a la ley de Derechos de Autor Internacional. Este eBook no puede ser prestado legalmente ni regalado a otros. Ninguna parte de este eBook puede ser compartida o reproducida sin el permiso expreso de la editorial. Para solicitar el permiso y resolver cualquier duda, contactar con Dreamspinner Press 5032 Capital Cir.</span> <span class="t2">SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886 USA or http://www.dreamspinnerpress.com/.</span></p>
<p class="p3"><span class="t2">Edición eBook en español: 978-1-62380-882-2</span></p>
<p class="p3"><span class="t2">Primera edición en español: Enero 2015</span></p>
<p class="p2"><span class="t2">Primera Edición Marzo 2010</span></p>
<p class="p0"><span class="t2">Publicado en los Estados Unidos de América.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?a72629be